
import { defineComponent } from "vue";

export default defineComponent({
  name: "mmi-structure-skeleton",
});
